<template>
    <div v-if="cert_data != null">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <center>
            <!-- <v-btn class="button no-display" @click="exportToPDF">Export to PDF</v-btn> -->
            <v-btn class="button no-display" @click="print"> Print </v-btn>
            <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
        </center>
        <template>
            <!-- <div id="printMe">
                <v-card class="cert-box v-card" flat>
                    <v-row justify="center">
                        <v-col cols="12" sm="2" md="2" align="right">
                            <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/sbpps_logos/logo_2.jpeg" width="75%" alt="logo" />
                        </v-col>
                        <v-col cols="12" sm="8" md="8">
                            <center>
                                <br />
                                <strong>PIMPRI CHINCHWAD EDUCATION TRUST`S</strong><br />
                                <strong>S.B. PATIL PUBLIC SCHOOL, Ravet</strong><br />
                                Survey No. 110, Gat No.1, Ravet - 412101<br />
                                Phone : 7030183183
                            </center>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" align="left">
                            <br />
                            <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/sbpps_logos/logo_1.jpeg" width="50%" alt="logo" />
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="ml-2">
                        <v-col cols="12" sm="4" md="4">
                            <strong>Affiliation No: 1130534</strong><br />
                            <strong v-if="cert_data!=null">No. {{ cert_data.cert_no }}</strong>
                        </v-col>
                        <v-col cols="12" sm="5" md="5"></v-col>
                        <v-col cols="12" sm="3" md="3">Date: {{ cert_data.cert_date }}</v-col>
                    </v-row>
                    <center>
                        <strong> <span style="font-size: 1.3em;">To whom so ever it may concern</span> </strong>
                    </center>
                    <br />
                    <v-row class="ml-2">
                        <v-col cols="12" sm="10" md="10" style="font-size: 1.3em;">
                            <i>
                                This. is to verify that Miss / Master <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px;">{{ cert_data.stud_name }}</span></strong>
                            </i>
                            <br />
                            <br />
                            is / was the student of standard
                            <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px;">{{ cert_data.std }}</span></strong>
                            Div.
                            <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px;">{{ cert_data.div }}</span></strong>
                            for the academic year <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px;">{{ cert_data.ay }}</span></strong><br />
                            <br />
                            His / Her Date of birth date according to our record is
                            <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px;">{{ cert_data.dob }}</span></strong><br />
                            <br />
                            His / Her address is <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px;">{{ cert_data.address }}</span></strong>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" style="font-size: 1.3em;">
                            <img v-if="cert_data.photo!=null" :src="awspath + cert_data.photo" width="75%" alt="logo" />
                        </v-col>
                    </v-row>
                    <v-row class="ml-2">
                        <v-col cols="12" sm="10" md="10" style="font-size: 1.3em;">
                            His / Her character is good. This certificate is issued for Ration card/ Bank account/ Aadhar Card/Caste Certificate.
                        </v-col>
                    </v-row>
                    <br />
                    <br />
                    <br />
                    <span class="bottomright" style="font-size: 1.3em;"><strong>PRINCIPAL</strong></span>
                </v-card>
            </div> -->
            <div v-if="show == true" ref="document" style="width=1000px;height:780px">
                <!-- {{org_basic_data}} -->
                <div class="printdiv v-card" style="
            border: 3px solid;
            border-color: black;
            position: absolute;
            padding: 10px;
            margin-left: 6%;
            margin-right: 6%;
            margin-top: 5%;
          ">
                    <v-row justify="center">
                        <v-col cols="12" sm="2" md="2" align="right">
                            <img v-if="org_basic_data.trust_logo" :src="org_basic_data.trust_logo" width="75%"
                                alt="logo" />
                        </v-col>
                        <v-col cols="12" sm="8" md="8">
                            <center>
                                <br />
                                <strong>
                                    <span v-if="org_basic_data.trust_name">{{
                                        org_basic_data.trust_name
                                    }}</span></strong><br />
                                <strong>
                                    <h1 class="schl-name" v-if="org_basic_data.trust_name">
                                        {{ org_basic_data.school_name }}
                                    </h1>
                                </strong>
                                <b v-if="this.org_id == 'sbpps'">CBSE Affiliated & NABET Accredited <br>
                                    QS I-GAUGE Diamond Rated</b><br>
                                <!-- <br /> -->
                                <span v-if="org_basic_data.address">{{
                                    org_basic_data.address
                                }}</span><br />
                                <span class="pr-8" v-if="org_basic_data.phone"><b>Phone : </b> {{ org_basic_data.phone
                                    }}</span>

                                <span v-if="org_basic_data.email"><b>Email : </b> {{ org_basic_data.email }}</span>
                                <br />
                                <span v-if="org_basic_data.website"><b>Website : </b> {{ org_basic_data.website
                                    }}</span>
                            </center>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" align="left">
                            <br />
                            <img :src="org_basic_data.school_logo" width="50%" alt="logo" />
                        </v-col>
                    </v-row>
                    <v-row justify="center" class="ml-2">
                        <v-col cols="12" sm="4" md="4">
                            <strong>Affiliation No: 1130534</strong><br />
                            <strong v-if="cert_data != null">Sr. No. {{ cert_data.cert_no }}</strong>
                        </v-col>
                        <v-col cols="12" sm="5" md="5"></v-col>
                        <v-col align="right" cols="12" sm="3" md="3"><span style="margin-right: 15%">Date: {{
                            cert_data.cert_date
                                }}</span></v-col>
                    </v-row>
                    <center>
                        <strong>
                            <span style="font-size: 1.3em; text-transform: uppercase">To whomsoever it may
                                concern</span>
                        </strong>
                    </center>
                    <br />
                    <v-row class="ml-2">
                        <v-col cols="12" sm="10" md="10" style="font-size: 1.3em">
                            <i>
                                This is to verify that Miss / Master
                                <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{
                                    cert_data.stud_name
                                        }}</span></strong>
                            </i>
                            <br />
                            <br />
                            is / was the student of Grade
                            <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.std
                                    }}</span></strong>
                            Div.
                            <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.div
                                    }}</span></strong>
                            for the academic year
                            <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.ay
                                    }}</span></strong><br />
                            <br />
                            His / Her Date of birth according to our record is
                            <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{ cert_data.dob
                                    }}</span></strong><br />
                            <br />
                            His / Her address is
                            <strong><span style="border-bottom: 2px solid #000; padding-bottom: 2px">{{
                                cert_data.address
                                    }}</span></strong>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" style="font-size: 1.3em">
                            <img v-if="cert_data.photo != null" :src="awspath + cert_data.photo" width="75%"
                                alt="logo" />
                        </v-col>
                    </v-row>
                    <v-row class="ml-2">
                        <v-col cols="12" sm="10" md="10" style="font-size: 1.3em">
                            He / She bears a good moral character. This certificate is issued
                            for Ration card / Bank account / Aadhaar Card / Caste Certificate /
                            VISA / Passport.
                        </v-col>
                    </v-row>
                    <br />
                    <br />
                    <br />
                    <br />
                    <!-- <br /><br /><br /><br /> -->
                    <div class="bottomright1">
                        <span style="font-size: 1.3em"><strong>PRINCIPAL</strong></span>
                    </div>
                </div>
            </div>

            <!-- </v-card> -->
        </template>
    </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            snackbar: false,
            fetch_loader: false,
            gen_cert_loader: false,
            show_cert_loader: false,
            search: "",
            dialog: false,
            awspath: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            data_list: [],
            ay_std_div_list: null,
            sel_ay_data: null,
            cert_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            overlay: false,
            show: true,
            org_id: null,
            org_basic_data: [],
            htmlToPdfOptions: {
                margin: 0,

                filename: `hehehe.pdf`,

                image: {
                    type: "jpeg",
                    quality: 0.98,
                },

                enableLinks: false,

                html2canvas: {
                    scale: 1,
                    useCORS: true,
                },

                jsPDF: {
                    unit: "in",
                    format: "a4",
                    orientation: "landscape",
                },
            },
            progress: 0,
        };
    },
    watch: {
        progress(val) {
            this.$emit("progress", val);
        },
    },
    components: {
        VueHtml2pdf,
        // "pdf-content": PdfContent,
    },
    methods: {
        makePDF() {
            window.html2canvas = html2canvas;
            var doc = new jsPDF("l", "pt", "a4");
            doc.html(document.querySelector("#app"), {
                callback: function (pdf) {
                    pdf.save("mypdf.pdf");
                },
            });
        },
        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        close() {
            this.$router.push({ name: "get-Certificate-Report", target: "blank" });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        onload() {
            this.cert_data = JSON.parse(localStorage.getItem("cert_data"));
            this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
        },
        async exportToPDF() {
            console.log("hi");
            await html2pdf(this.$refs.document, {
                enableLinks: false,
                margin: 0,
                filename: "document.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 1, useCORS: true },
                jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
            });
            console.log("hi1");
        },
        generateReport() {
            this.beforeDownload();
            this.$refs.html2Pdf.generatePdf();
        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf()
                .set(options)
                .from(pdfContent)
                .toPdf()
                .get("pdf")
                .then((pdf) => {
                    const totalPages = pdf.internal.getNumberOfPages();
                    for (let i = 1; i <= totalPages; i++) {
                        pdf.setPage(i);
                        pdf.setFontSize(10);
                        pdf.setTextColor(150);
                        pdf.text(
                            "Page " + i + " of " + totalPages,
                            pdf.internal.pageSize.getWidth() * 0.88,
                            pdf.internal.pageSize.getHeight() - 0.3
                        );
                    }
                })
                .save();
        },
    },
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.org_id = localStorage.getItem("EPS-tenant");
        this.onload();
    },
};
</script>
<style scoped>
.cert-box {
    border: 2px solid #0f2027 !important;
    /*margin-top: 2%;
        margin-right: 12%;
        margin-left: 12%;
        padding: 10px; */
    /* margin: 15px !important;
        padding: 8px; */
    margin-top: 5%;
    margin-right: 10%;
    margin-left: 10%;
    padding: 10px;
}

.bottomright {
    position: absolute;
    bottom: 8px;
    right: 16px;
    font-size: 18px;
    margin-top: 20px;
}

.bottomright1 {
    text-align: right;
    margin-top: 15px;
}

@media print {
    .printdiv {
        height: 1600px;
        width: 2100px;
        margin-top: -5px !important;
    }

    /* .schl-name {
    font-size: 50px;
  } */

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    img {
        width: 100% !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .v-card {
        font-size: 2em !important;
    }

    @page {
        /* margin-top: -4%; */
        size: A4 landscape;
        /* size: 25.5in 19in; */
        size: 25in 18.5in;
    }

    * {
        overflow: hidden !important;
    }
}

/* .schl-name {
  font-size: x-large;
} */
</style>
